<div class="flex flex-col items-between w-full h-full bg-white">
  <div class="flex justify-start items-center w-full h-20 bg-white border-b border-gray-200 px-5 shrink-0">
    <img src="images/attestio-logo.png" alt="Logo Attestio" class="h-8 w-auto"/>
  </div>
  @if (showCompanySelector()) {
    <app-company-selector></app-company-selector>
  }
  <div class="flex flex-col justify-between flex-1 min-h-0 overflow-y-auto">
    <div class="pt-0">
      <app-sidebar-navigation></app-sidebar-navigation>
    </div>
    <div class="border-t border-gray-200">
      <app-sidebar-navigation-logout></app-sidebar-navigation-logout>
    </div>
  </div>
</div>
